import React from 'react'
import { useTranslation } from 'react-i18next'
import cartSuccess from 'img/cart-confirmed'

const PaymentAuthorizedCallout = ({cart, endpoint, paymentUrl}) => {
  const { t, i18n } = useTranslation()

  return (
    <React.Fragment>
      <div className="alert alert-success mb-4 d-flex flex-column flex-md-row justify-content-start" role="alert">
        <div className="text-center me-md-4">
          <img width="110" height="110" className="me-3" src={cartSuccess} alt="Pago autorizado" />
        </div>
        <div className="w-100 mt-3 mt-md-0">
          <div className="alert-heading d-flex flex-column flex-md-row justify-content-between m-0 p-0">
            <div className="align-self-center">
              <h5 className="alert-heading">{i18n.t('payment_authorized_callout.payment_authorized_title')}</h5>
            </div>
          </div>
          <hr/>
          <h4 className="m-0">{i18n.t('payment_authorized_callout.payment_authorized_description')}</h4>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PaymentAuthorizedCallout